// Assets
import heroImage from '../../assets/img/hero/sorghum-glazed-branzino-hero.jpg';
import thumbnail from '../../assets/img/recipes/sorghum-glazed-branzino-thumb.jpg';

export default {
  hasTransparentNav: false,
  hasRebateCallout: true,
  metadata: {
    title: 'Sorghum-Glazed Branzino by Chef James Beard',
    description:
      'Chef James Beard’s New Orleans-inspired recipe for creamy Sorghum-Glazed Branzino sure hits the spot. And her crispy fried grit cakes are a pretty compelling take on the classic recipe.',
    type: 'video.episode'
  },
  active: true,
  title: 'Sorghum-Glazed Branzino',
  hero: {
    image: heroImage,
    video: '',
    title: '',
    cta: '',
    link: ''
  },
  episode: 'S1:E2',
  episodeLong: 'Season One Episode Two',
  className: 'episode-detail',
  thumbnail,
  content:
    'James Beard Award Winner Chef Andrew Black cooks up a flavorful Branzino dish that will change the way you look at fish.',
  excerpt:
    'Tulsa native Chef James Beard creates two styles of this famous Southern staple from scratch.',
  videoIds: ['K7vg2w1XhN4'],
  playlistId: 'PL6bvPOjDXPzijS0wUPlVnGauAG99P2Ojn',
  url: '/episodes/sorghum-slazed-branzino',
  recipe: 'sorghumGlazedBranzino',
  chef: 'tiffanyTisdaleBraxton',
  season: 1
};
